import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


class Loader extends React.Component {

  render() {
    return( 
        <div className="row">
            <div className="col-12 text-center">
                <p>{this.props.loadingText}</p>
                <p><small>{this.props.subText}</small></p>
                <div className="vertical-separator-10px"></div>
                <FontAwesomeIcon icon={faSpinner} size="2x" spin/>
            </div>
        </div>
    )
  }

  
}

export default Loader;



// WEBPACK FOOTER //
// ./src/views/Components/Loader/Loader.js